import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const ChartLegendSkeleton: React.FC = () => (
  <Box
    sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2, width: '100%' }}
  >
    <Skeleton variant="rectangular" width={80} height={20} />
  </Box>
);
